"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema = {
    schemaType: "object",
    properties: [
        {
            title: "ロゴ",
            propertyName: "logoUrl",
            schema: {
                schemaType: "image",
                maxHeight: 30,
            },
        },
        {
            title: "プロジェクト名",
            propertyName: "projectName",
            schema: {
                schemaType: "text",
                required: true,
            },
        },
    ],
};
exports.default = schema;
